import {
  GTG_TYPE_SYMPTOM_CHECKER,
  normalizeGtgType,
  filterValidLocalCarouselSlidesForPublish,
} from "@healthdesk/shared-utils";
import { LISTING_TYPE_LOCAL_CAROUSEL } from "./localCarouselFacilityConstants";
import { localCarouselAdVisibleOnMap } from "./localCarouselPatientFilter";

/**
 * Strip tags so the standalone /symptomchecker line is plain text (slide.message may be reused on CareMap with HTML).
 * @param {unknown} message
 * @returns {string}
 */
export function plainSponsorNameFromSlideMessage(message) {
  const raw = typeof message === "string" ? message.trim() : "";
  if (!raw) return "";
  return raw.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
}

/**
 * Pick the winning Symptom Checker GTG listing for the viewer (zip query already scoped).
 * Rows must be sorted like CareMap (CPC desc, then carousel listing order, then doc id).
 *
 * @param {{ listingData: Record<string, unknown>, docId: string }[] | null | undefined} rows
 * @param {string | null | undefined} role
 * @param {Record<string, unknown> | null | undefined} userData
 * @returns {{ sponsorName: string, logoUrl: string } | null}
 */
export function pickSymptomCheckerAttributionFromListingRows(rows, role, userData) {
  if (!Array.isArray(rows) || rows.length === 0) {
    return null;
  }
  for (const { listingData } of rows) {
    if (normalizeGtgType(listingData?.gtgType) !== GTG_TYPE_SYMPTOM_CHECKER) {
      continue;
    }
    const valid = filterValidLocalCarouselSlidesForPublish(
      listingData?.localCarouselSlides
    );
    if (valid.length !== 1) {
      continue;
    }
    const slide = valid[0];
    const ad = {
      type: LISTING_TYPE_LOCAL_CAROUSEL,
      gtgTargetAudience: listingData.gtgTargetAudience,
      patientGender: slide.patientSegments?.gender,
      patientSegments: slide.patientSegments,
    };
    if (!localCarouselAdVisibleOnMap(ad, role, userData)) {
      continue;
    }
    const fromSlide = plainSponsorNameFromSlideMessage(slide.message);
    const facilityFallback =
      typeof listingData?.facilityName === "string"
        ? listingData.facilityName.trim()
        : "";
    const sponsorName = fromSlide || facilityFallback;
    if (!sponsorName) {
      continue;
    }
    return {
      sponsorName,
      logoUrl: typeof slide.logoUrl === "string" ? slide.logoUrl.trim() : "",
    };
  }
  return null;
}
